"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gifOverlayColor = exports.dimColor = exports.secondaryCTA = exports.primaryCTADisabled = exports.primaryCTA = exports.deleteColor = exports.errorColor = exports.smsColor = exports.redditColor = exports.instagramColor = exports.tumblrColor = exports.pinterestColor = exports.twitterColor = exports.facebookColor = exports.giphyPink = exports.giphyIndigo = exports.giphyLightBlue = exports.giphyAqua = exports.giphyYellow = exports.giphyRed = exports.giphyPurple = exports.giphyGreen = exports.giphyBlue = exports.giphyWhite = exports.giphyWhiteSmoke = exports.giphyLightestGrey = exports.giphyLightGrey = exports.giphyLightCharcoal = exports.giphyCharcoal = exports.giphyDarkCharcoal = exports.giphyDarkGrey = exports.giphyDarkestGrey = exports.giphyBlack = void 0;
/* greys */
exports.giphyBlack = '#121212';
exports.giphyDarkestGrey = '#212121';
exports.giphyDarkGrey = '#2e2e2e';
exports.giphyDarkCharcoal = '#3e3e3e';
exports.giphyCharcoal = '#4a4a4a';
exports.giphyLightCharcoal = '#5c5c5c';
exports.giphyLightGrey = '#a6a6a6';
exports.giphyLightestGrey = '#d8d8d8';
exports.giphyWhiteSmoke = '#ececec';
exports.giphyWhite = '#ffffff';
/* primary */
exports.giphyBlue = '#00ccff';
exports.giphyGreen = '#00ff99';
exports.giphyPurple = '#9933ff';
exports.giphyRed = '#ff6666';
exports.giphyYellow = '#fff35c';
/* secondary */
exports.giphyAqua = '#00e6cc';
exports.giphyLightBlue = '#3191ff';
exports.giphyIndigo = '#6157ff';
exports.giphyPink = '#e646b6';
/* social */
exports.facebookColor = '#3894fc';
exports.twitterColor = '#00ccff';
exports.pinterestColor = '#e54cb5';
exports.tumblrColor = '#529ecc';
exports.instagramColor = '#c23c8d';
exports.redditColor = '#fc6669';
exports.smsColor = '#00ff99';
/* functional */
exports.errorColor = exports.giphyRed;
exports.deleteColor = exports.giphyRed;
exports.primaryCTA = exports.giphyIndigo;
exports.primaryCTADisabled = '#241F74';
exports.secondaryCTA = exports.giphyCharcoal;
exports.dimColor = "rgba(0, 0, 0, 0.8)";
exports.gifOverlayColor = "rgba(0, 0, 0, 0.4)";
//# sourceMappingURL=colors.js.map